// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-message-box__footer {
  gap: 0.65rem;
}

:host ::ng-deep .dynamic-message-box__primary-action,
:host ::ng-deep .dynamic-message-box__secondary-action,
:host ::ng-deep .dynamic-message-box__danger-action {
  min-height: 2.35rem;
  padding: 0.5rem 1.05rem;
  border-radius: 0.45rem;
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.2;
  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease, box-shadow 0.16s ease;
}

:host ::ng-deep .dynamic-message-box__primary-action {
  border: 1px solid #0b75bd;
  background: #0b75bd;
  color: #ffffff;
}

:host ::ng-deep .dynamic-message-box__primary-action:hover,
:host ::ng-deep .dynamic-message-box__primary-action:focus-visible {
  border-color: #095f99;
  background: #095f99;
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(11, 117, 189, 0.18);
}

:host ::ng-deep .dynamic-message-box__secondary-action {
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #334155;
}

:host ::ng-deep .dynamic-message-box__secondary-action:hover,
:host ::ng-deep .dynamic-message-box__secondary-action:focus-visible {
  border-color: #94a3b8;
  background: #f8fafc;
  color: #0f2742;
}

:host ::ng-deep .dynamic-message-box__danger-action {
  border: 1px solid #f75d5d;
  background: #f75d5d;
  color: #ffffff;
}

:host ::ng-deep .dynamic-message-box__danger-action:hover,
:host ::ng-deep .dynamic-message-box__danger-action:focus-visible {
  border-color: #f52929;
  background: #f52929;
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(220, 38, 38, 0.14);
}

:host ::ng-deep .processing-delete-dialog {
  display: grid;
  gap: 0.9rem;
  color: #1f2937;
}

:host ::ng-deep .processing-delete-dialog__intro,
:host ::ng-deep .processing-delete-dialog__note,
:host ::ng-deep .processing-delete-dialog__warning {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.55;
}

:host ::ng-deep .processing-delete-dialog__intro {
  color: #263b55;
  font-weight: 600;
}

:host ::ng-deep .session-delete-details {
  display: grid;
  gap: 0.625rem;
  padding: 1rem 1.125rem;
  border-radius: 0.625rem;
  background: #f8fafc;
  border: 1px solid #d8e6f3;
}

:host ::ng-deep .session-delete-detail-row {
  display: grid;
  grid-template-columns: 12rem minmax(0, 1fr);
  align-items: flex-start;
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}

:host ::ng-deep .session-delete-detail-label {
  color: #64748b;
  font-size: 0.8125rem;
  font-weight: 700;
}

:host ::ng-deep .session-delete-detail-value {
  min-width: 0;
  color: #0f2742;
  font-size: 0.875rem;
  font-weight: 600;
  overflow-wrap: anywhere;
}

:host ::ng-deep .processing-delete-dialog__note {
  padding: 0.75rem 0.9rem;
  border-left: 3px solid #f59e0b;
  border-radius: 0.5rem;
  background: #fff7e6;
  color: #92400e;
  font-weight: 600;
}

:host ::ng-deep .processing-delete-dialog__warning {
  padding: 0.875rem 1rem;
  border-left: 3px solid #ef4444;
  border-radius: 0.5rem;
  background: #fff8f8;
  color: #7f1d1d;
  font-weight: 600;
}

@media (max-width: 576px) {
  :host ::ng-deep .session-delete-detail-row {
    grid-template-columns: 1fr;
    row-gap: 0.2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/message-box/components/dynamic-message-box/dynamic-message-box.component.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;AADJ;;AAIA;;;EAGI,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yGAAA;AADJ;;AAIA;EACI,yBAAA;EACA,mBAAA;EACA,cAAA;AADJ;;AAIA;;EAEI,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,+CAAA;AADJ;;AAIA;EACI,yBAAA;EACA,mBAAA;EACA,cAAA;AADJ;;AAIA;;EAEI,qBAAA;EACA,mBAAA;EACA,cAAA;AADJ;;AAIA;EACI,yBAAA;EACA,mBAAA;EACA,cAAA;AADJ;;AAIA;;EAEI,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,8CAAA;AADJ;;AAIA;EACI,aAAA;EACA,WAAA;EACA,cAAA;AADJ;;AAIA;;;EAGI,SAAA;EACA,kBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,cAAA;EACA,gBAAA;AADJ;;AAIA;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AADJ;;AAIA;EACI,aAAA;EACA,2CAAA;EACA,uBAAA;EACA,qBAAA;OAAA,gBAAA;AADJ;;AAIA;EACI,cAAA;EACA,oBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,YAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADJ;;AAIA;EACI,uBAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AADJ;;AAIA;EACI,sBAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AADJ;;AAIA;EACI;IACI,0BAAA;IACA,eAAA;EADN;AACF","sourcesContent":["@import 'styles/core/variables.scss';\n\n.dynamic-message-box__footer {\n    gap: 0.65rem;\n}\n\n:host ::ng-deep .dynamic-message-box__primary-action,\n:host ::ng-deep .dynamic-message-box__secondary-action,\n:host ::ng-deep .dynamic-message-box__danger-action {\n    min-height: 2.35rem;\n    padding: 0.5rem 1.05rem;\n    border-radius: 0.45rem;\n    font-size: 0.9rem;\n    font-weight: 600;\n    line-height: 1.2;\n    transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease, box-shadow 0.16s ease;\n}\n\n:host ::ng-deep .dynamic-message-box__primary-action {\n    border: 1px solid #0b75bd;\n    background: #0b75bd;\n    color: #ffffff;\n}\n\n:host ::ng-deep .dynamic-message-box__primary-action:hover,\n:host ::ng-deep .dynamic-message-box__primary-action:focus-visible {\n    border-color: #095f99;\n    background: #095f99;\n    color: #ffffff;\n    box-shadow: 0 6px 14px rgba(11, 117, 189, 0.18);\n}\n\n:host ::ng-deep .dynamic-message-box__secondary-action {\n    border: 1px solid #cbd5e1;\n    background: #ffffff;\n    color: #334155;\n}\n\n:host ::ng-deep .dynamic-message-box__secondary-action:hover,\n:host ::ng-deep .dynamic-message-box__secondary-action:focus-visible {\n    border-color: #94a3b8;\n    background: #f8fafc;\n    color: #0f2742;\n}\n\n:host ::ng-deep .dynamic-message-box__danger-action {\n    border: 1px solid #f75d5d;\n    background: #f75d5d;\n    color: #ffffff;\n}\n\n:host ::ng-deep .dynamic-message-box__danger-action:hover,\n:host ::ng-deep .dynamic-message-box__danger-action:focus-visible {\n    border-color: #f52929;\n    background: #f52929;\n    color: #ffffff;\n    box-shadow: 0 6px 14px rgba(220, 38, 38, 0.14);\n}\n\n:host ::ng-deep .processing-delete-dialog {\n    display: grid;\n    gap: 0.9rem;\n    color: #1f2937;\n}\n\n:host ::ng-deep .processing-delete-dialog__intro,\n:host ::ng-deep .processing-delete-dialog__note,\n:host ::ng-deep .processing-delete-dialog__warning {\n    margin: 0;\n    font-size: 0.95rem;\n    line-height: 1.55;\n}\n\n:host ::ng-deep .processing-delete-dialog__intro {\n    color: #263b55;\n    font-weight: 600;\n}\n\n:host ::ng-deep .session-delete-details {\n    display: grid;\n    gap: 0.625rem;\n    padding: 1rem 1.125rem;\n    border-radius: 0.625rem;\n    background: #f8fafc;\n    border: 1px solid #d8e6f3;\n}\n\n:host ::ng-deep .session-delete-detail-row {\n    display: grid;\n    grid-template-columns: 12rem minmax(0, 1fr);\n    align-items: flex-start;\n    column-gap: 1rem;\n}\n\n:host ::ng-deep .session-delete-detail-label {\n    color: #64748b;\n    font-size: 0.8125rem;\n    font-weight: 700;\n}\n\n:host ::ng-deep .session-delete-detail-value {\n    min-width: 0;\n    color: #0f2742;\n    font-size: 0.875rem;\n    font-weight: 600;\n    overflow-wrap: anywhere;\n}\n\n:host ::ng-deep .processing-delete-dialog__note {\n    padding: 0.75rem 0.9rem;\n    border-left: 3px solid #f59e0b;\n    border-radius: 0.5rem;\n    background: #fff7e6;\n    color: #92400e;\n    font-weight: 600;\n}\n\n:host ::ng-deep .processing-delete-dialog__warning {\n    padding: 0.875rem 1rem;\n    border-left: 3px solid #ef4444;\n    border-radius: 0.5rem;\n    background: #fff8f8;\n    color: #7f1d1d;\n    font-weight: 600;\n}\n\n@media (max-width: 576px) {\n    :host ::ng-deep .session-delete-detail-row {\n        grid-template-columns: 1fr;\n        row-gap: 0.2rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
